import { CheckIcon } from "components/Icons";
import { SMALL } from "shared/constants";
import cx from "classnames";
import styles from "./CheckList.module.css";

export const CheckList = ({ items, size }) => (
  <ul className={cx(styles.checkList, { [styles.small]: size === SMALL })}>
    {(items || []).map(({ label }, i) => (
      <li key={i}>
        <span className={styles.icon}>
          <CheckIcon />
        </span>
        {label}
      </li>
    ))}
  </ul>
);
